export default __webpack_public_path__ + "static/service_02-02a10fc9111aa34b602808d95400dd6c.jpg";